/**
 * Zentrale Formatierung für Versteck-Namen (Dropdowns, Karten, Auswahl-Tabs).
 * Einzige Quelle für Typ-Label-Zuordnung + Spitzname-Anzeige — nicht pro Feature duplizieren
 * (analog zum item-badges.ts-Prinzip).
 */

/** Kanonische Anzeige-Namen je Versteck-subType. */
export const HIDEOUT_TYPE_LABELS: Record<string, string> = {
  dachboden:       'Dachboden',
  hinterzimmer:    'Hinterzimmer',
  wohnung:         'Wohnung',
  kellerstudio:    'Kellerstudio',
  gartenlaube:     'Gartenlaube',
  campingwagen:    'Campingwagen',
  bungalow:        'Bungalow',
  luxus_apartment: 'Luxus-Apartment',
  lagercontainer:  'Lagercontainer',
  bootshaus:       'Bootshaus',
  bunker:          'Bunker',
  // NT-HIDEOUT-PROFILE-01
  waschkeller:       'Waschkeller',
  kirchturm:         'Kirchturm',
  tiefgaragenabteil: 'Tiefgaragenabteil',
  schrebergarten:    'Schrebergarten',
  doenerbude:        'Dönerbude',
  kegelbahn:         'Kegelbahn',
  tankstelle:        'Tankstelle',
  sparkassenfiliale: 'Sparkassenfiliale',
};

export interface HideoutNameParts {
  subType:      string;
  customName?:  string | null;
  nickname?:    string | null;
}

/**
 * Basis-Name: customName falls gesetzt, sonst Typ-Label (Override erlaubt für Stellen,
 * die das Label bereits vom Backend geliefert bekommen). Zusätzlich additiv " — {nickname}"
 * falls ein Spitzname gesetzt ist.
 */
export function formatHideoutName(h: HideoutNameParts, typeLabelOverride?: string): string {
  const baseLabel = h.customName ?? typeLabelOverride ?? HIDEOUT_TYPE_LABELS[h.subType] ?? h.subType;
  return h.nickname ? `${baseLabel} — ${h.nickname}` : baseLabel;
}
